import React, { useEffect, useRef, useState } from "react";
import { Form, Button, Row, Col, Card } from "antd";
import axios from "axios";
import CentralBillingOnly from "./programs/components/CentralBillingOnly";
import ReimbursementAddress from "./programs/components/ReimbursementAddress";
import { getManufacturerByProgram } from "@/libs/util";
import { useNavigate } from "react-router-dom";
import ProgramForm from "@/components/ProgramForm.jsx";
import ConsentDialog from "@/components/ConsentDialog/index.jsx";
import useGlobalConfig from "@/store/global";
import { notification, message } from "antd";
import { programLabels } from "@/config";
import dayjs from "dayjs";

const needConsentPrograms = ['wilate', 'nuwiq', 'cutaquig', 'octagam', 'fibryga', 'panzyga']

const AssistanceRequestFormNew = () => {
  const { program, meData, themeColor, updateMeData } = useGlobalConfig();
  const [notificationApi, notificationContextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const consentDialogRef = useRef(null);
  const isOctaPharma = getManufacturerByProgram(program.name)?.indexOf("Octapharma") !== -1
  const renderConsentDialog = needConsentPrograms.includes(program.name)
  const [icdCodeNames, setIcdCodeNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const loadMeData = async () => {
    try {
      const { data } = await axios.get("sessions/me");
      updateMeData(data);
    } catch (error) {
      console.log(error);
    }
  }

  const loadData = async () => {
    const { data } = await axios.get("programs/icd_code_names");
    setIcdCodeNames(data);
  };

  let renderRef = useRef(false);

  useEffect(() => {
    if (renderRef.current) {
      renderRef.current = false;
      return;
    }
    loadMeData()
    loadData();
  }, []);

  const handleSubmitConsent = async () => {
    const values = await form.validateFields();
    try {
      setLoading(true);

      const { data, error } = await axios.post(`assistance_requests`, {
        ... values,
        date_of_birth: dayjs(values.date_of_birth).format('YYYY-MM-DD'),
        date_prescription_written: dayjs(values.date_prescription_written).format('YYYY-MM-DD'),
        expected_dispensing_date: dayjs(values.expected_dispensing_date).format('YYYY-MM-DD'),
        help_consent: true,
      });
      console.log("response: ", data);
      navigate(`/assistance_requests/${data.id}/show?submitted=true`);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  const handleSubmit = async (values) => {
    console.log("Received values of form: ", values);

    try {
      setLoading(true);

      const { data, error } = await axios.post(`assistance_requests`, {
        ... values,
        date_of_birth: dayjs(values.date_of_birth).format('YYYY-MM-DD'),
        date_prescription_written: dayjs(values.date_prescription_written).format('YYYY-MM-DD'),
        expected_dispensing_date: dayjs(values.expected_dispensing_date).format('YYYY-MM-DD'),
      }, {
        customError: true,
      });
      navigate(`/assistance_requests/${data.id}/show?submitted=true`);
    } catch (e) {
        const errorMessage = e?.data?.message?.split('\n')?.[0] || e?.data?.message
        if (errorMessage?.includes('Patient must consent') && isOctaPharma) {
          if (needConsentPrograms.includes(program.name)) {
            message.error(errorMessage, 5);
            return consentDialogRef.current.open();
          }
        }
        notificationApi.error({
          message: errorMessage,
          duration: 0,
        });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {
        notificationContextHolder
      }
      <div className={isOctaPharma ? 'octapharma-form' : ''}>
        <div className="mx-auto max-w-screen-xl">
          <h1 className="mb-4 text-xl md:text-2xl font-bold">
            {programLabels[program.name].title}
          </h1>
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <Card className="mb-6 bg-zinc-50">
              <ProgramForm
                programName={program.name}
                icdCodeNames={icdCodeNames}
                meData={meData}
              />
            </Card>

            <CentralBillingOnly meData={meData} />

            <ReimbursementAddress meData={meData} />

            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 14,
              }}
            >
              <Button
                disabled={loading}
                loading={loading}
                type='primary'
                htmlType='submit'
                style={{
                  width: "60%",
                  backgroundColor: themeColor,
                  height: "40px",
                  fontSize: "18px",
                  marginTop: "30px",
                }}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
      {
        renderConsentDialog && <ConsentDialog ref={consentDialogRef} submit={handleSubmitConsent} />
      }
    </>
  );
};

export default AssistanceRequestFormNew;
